import { useContext, useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { developOptions } from "../../../../../../../../../config/developOptions";
import { ProcessContext } from "../../../../../../../../../contexts/ProcessContext";
import { useActionCallback } from "../../../../../../../../../utils/hooks/useActionCallback";

export const useEurobits = () => {
  const {
    state: { loan, participant },
    dispatch,
  } = useContext(ProcessContext);

  const [state, setState] = useState({
    visibleComponent: undefined,
    bankReaderSuccess: false,
    processId: uuidv4(),
    borrowerBankReaderId: uuidv4(),
    borrowerCashInCashOutMethodId: uuidv4(),
    iban: undefined,
  });

  const {
    bankReaderSuccess,
    processId,
    borrowerBankReaderId,
    borrowerCashInCashOutMethodId,
    iban,
  } = state;

  useEffect(() => {
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: { show: true },
    });
    dispatch({
      type: "REQUEST_GET_PROCESS_IDS",
      payload: loan.id,
    });
  }, []);

  useActionCallback("REQUEST_GET_PROCESS_IDS_FULFILLED", () => {
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: { show: false },
    });
  });

  useActionCallback("REQUEST_GET_PROCESS_IDS_REJECTED", () => {
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: { show: false },
    });
  });

  useActionCallback(
    "REQUEST_GET_BANK_READER_WIDGET_URL_EUROBITS_FULFILLED",
    () => {
      dispatch({
        type: "SET_FLOW_LOADING",
        payload: { show: false },
      });
      // dispatch({
      //   type: "SET_FLOW_LOADING",
      //   payload: { show: false },
      // });
    }
  );

  useEffect(() => {
    if (bankReaderSuccess === true && iban) {
      dispatch({
        type: "SET_FLOW_LOADING",
        payload: { show: true },
      });
      onAddCashInCashOutMethod(iban);
    }
  }, [bankReaderSuccess, iban]);

  const onSuccess = (accountNumber) => {
    if (bankReaderSuccess === false) {
      setState((s) => ({ ...s, iban: accountNumber, bankReaderSuccess: true }));
    }
  };

  const onError = () => setState((s) => ({ ...s, openWidget: false }));

  const onAddCashInCashOutMethod = (accountNumber) => {
    dispatch({
      type: "REQUEST_POST_ADD_CASH_IN_CASH_OUT_METHOD_EUROBITS",
      payload: {
        loan_id: loan.id,
        borrower_id: participant.participantId,
        cash_in_cash_out_method_id: borrowerCashInCashOutMethodId,
        borrower_bank_reader_id: borrowerBankReaderId,
        account_number: accountNumber,
      },
    });
  };

  const getBankReaderWidgetUrl = () => {
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: { show: true },
    });
    dispatch({
      type: "REQUEST_GET_BANK_READER_WIDGET_URL_EUROBITS",
      payload: {
        processId,
        documentIdNumber: developOptions.USE_FAKE_SERVICES_ON_POST_OR_PATCH
          ? "43260488H"
          : loan.borrower_user_details_on_origination?.document_id
              ?.document_number,
        borrowerBankReaderId,
        borrowerId: participant.participantId,
        loanId: loan.id,
      },
    });
  };

  return {
    onSuccess,
    onError,
    getBankReaderWidgetUrl,
  };
};
